// extracted by mini-css-extract-plugin
export default {"container":"header-title_container__2_9EX","quatre95":"header-title_quatre95__3LOMi","dehors":"header-title_dehors__2IpLU","mollo":"header-title_mollo__3d-Dv"};